import React, { Component } from "react";
import * as _ from "lodash";
import TenantPackageSummary from "../models/TenantPackageSummary";
import TableCell from "./TableCell";
import { Checkbox } from "office-ui-fabric-react";

interface TenantPackageSummaryListProps {
    title?: string;
    enableRowLinks: boolean;
    tenantPackageSummaries: TenantPackageSummary[];
    selectable?: boolean;
    onSelectionChange?: (selection: Map<string, boolean>) => void
}

interface TenantPackageSummaryListState {
    tenantsSelected: Map<string, boolean>
    lastSelectedTenantId: string | null;
    selectAll: boolean;
}

export default class TenantPackageSummaryList extends Component<TenantPackageSummaryListProps, TenantPackageSummaryListState>
{
    constructor(props: TenantPackageSummaryListProps) {
        super(props);

        this.state = {
            tenantsSelected: new Map<string, boolean>(),
            lastSelectedTenantId: null,
            selectAll: false,
        }
    }

    async componentDidUpdate(prevProps: Readonly<TenantPackageSummaryListProps>, prevState: Readonly<TenantPackageSummaryListState>, snapshot?: any): Promise<void> {
    }

    async componentDidMount() {

    }

    private onSelectAll(isChecked: boolean | undefined) {
        if (isChecked != undefined) {
            this.props.tenantPackageSummaries.forEach(tenant => {
                if (tenant.tenantId != undefined) {
                    this.state.tenantsSelected.set(tenant.tenantId, isChecked);
                }
            });
            this.setState({ tenantsSelected: this.state.tenantsSelected, selectAll: isChecked });
            this.props.onSelectionChange && this.props.onSelectionChange(this.state.tenantsSelected);
        }
    }

    private onChecked = (tenant: TenantPackageSummary, isChecked: boolean | undefined, isShiftClick: boolean)=> {
        
        if (tenant?.tenantId != undefined && isChecked != undefined)
        {
            let lastSelectedTenant: TenantPackageSummary | null = null;
            if(this.state.lastSelectedTenantId !== null)
            {
                lastSelectedTenant = this.props.tenantPackageSummaries.find(t => t.tenantId === this.state.lastSelectedTenantId) || null;   
            }
            
            if(isShiftClick && lastSelectedTenant !== null && isChecked)
            {
                const indexes = [this.props.tenantPackageSummaries.indexOf(tenant), this.props.tenantPackageSummaries.indexOf(lastSelectedTenant)].sort((a, b) => a - b);
                const start = indexes[0];
                const end = indexes[1];
                    
                this.props.tenantPackageSummaries.slice(start,end+1).forEach(t => {
                    this.state.tenantsSelected.set(t.tenantId!, true);
                });
            }
            else
            {
                this.state.tenantsSelected.set(tenant.tenantId, isChecked);
            }
            
            
            this.setState({ tenantsSelected: this.state.tenantsSelected, lastSelectedTenantId: isChecked ? tenant.tenantId : null });
            this.props.onSelectionChange && this.props.onSelectionChange(this.state.tenantsSelected);
        }
    }

    private isChecked(tenant: TenantPackageSummary): boolean {
        if (tenant?.tenantId != undefined) {
            var value = this.state.tenantsSelected.get(tenant.tenantId);
            return value ?? false;
        }
        return false;
    }


    private getLink(tenant: TenantPackageSummary) {
        return tenant ? `/cdb-admin/tenants/${tenant.tenantId}/package-management` : "";
    };

    private pillColour(count: number | undefined, max: number | undefined): string {
        if (count == null || max == null || (count == 0 && max == 0)) {
            return "grey";
        }

        var dif = max - count;
        if (dif > 0) {
            return "red";
        }
        else if (dif < 0) {
            return "amber";
        }
        else {
            return "green";
        }
    }

    private buildRow(tenant: TenantPackageSummary): JSX.Element {
        const row = (
            <div className="cdb-table__row" key={tenant.tenantId}>
                <TableCell to={this.getLink(tenant)} className="flex-item--flex-4" enableLink={this.props.enableRowLinks}>
                    <span>{tenant.tenantName}</span>
                    <span className="cdb-table__extra-detail">{tenant.tenantId}</span>
                </TableCell>
                <div className="cdb-table__cell flex-item--flex-4">
                    <span>
                        Packages Matching Targets
                        <span style={{ marginLeft: '5px' }} className={`pill pill--${this.pillColour(tenant.packagesMatchingTargetsCount, tenant.packagesCount)}`}>
                            ({tenant.packagesMatchingTargetsCount}/{tenant.packagesCount})
                        </span>
                    </span>
                </div>
                <div className="cdb-table__cell flex-item--flex-2">
                    <span>
                        {tenant.activeSchoolCount}
                    </span>
                </div>
                {
                    this.props.selectable == true &&
                    <div style={{ alignItems: "flex-end" }} className="cdb-table__cell flex-item--flex-1">
                        <Checkbox checked={this.isChecked(tenant)} onChange={(e, isChecked) => 
                        {
                            const nativeEvent = e?.nativeEvent as any;
                            this.onChecked(tenant, isChecked,nativeEvent.shiftKey)}
                        } />
                    </div>
                }
            </div>
        );

        return row;
    }

    public render() {
        const rows = this.props.tenantPackageSummaries.map((tenant) => this.buildRow(tenant));
        return (
            <div className="cdb-table">

                        <div className="card__header"
                            style={{ height: "auto", minHeight: "3rem" }}>
                            <span className={"card__title"}>{this.props.title ? this.props.title : ""}</span>
                            {this.props.children}
                        </div>

                        <div className="cdb-table__row cdb-table__row--header">
                            <div className="cdb-table__cell flex-item--flex-4">Name</div>
                            <div className="cdb-table__cell flex-item--flex-4">Packages</div>
                            <div className="cdb-table__cell flex-item--flex-2">
                                <span>Active Schools</span>
                                <span className="cdb-table__extra-detail">Licensed and not disabled</span>
                            </div>
                            {
                                this.props.selectable &&
                                <div style={{ alignItems: "flex-end" }} className="cdb-table__cell flex-item--flex-1">
                                    <Checkbox checked={this.state.selectAll} onChange={(e, isChecked) => this.onSelectAll(isChecked)} />
                                </div>
                            }
                        </div>
                        {rows}
                    </div>
        );
    }
}